var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es273.js.map
